

import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { take} from 'rxjs/operators';
import * as moment from 'moment';
import { Parameter, PeriodTypeEnum, Employee, Contribution, Loan, ContributionTypesEnum, ContributionSubTypesEnum, FinancialReturn, FundParameters } from '@akiba/models_bimbo';
import { LogicService } from '../../../services/logic.service';
import { AuthenticationService } from './../../../services/authentication.service';
import { DataSourceService } from '../../../services/data-source.service';
import { ChartType, ChartOptions, ChartColor } from 'chart.js';
import { SingleDataSet, Label, monkeyPatchChartJsLegend, monkeyPatchChartJsTooltip } from 'ng2-charts';

@Component({
  selector: 'app-dashboard-employee',
  templateUrl: './dashboard-employee.component.html',
  styleUrls: ['./dashboard-employee.component.scss']
})

export class DashboardEmployeeComponent implements OnInit {
  //////////////////////////////////////
  principalSubscription: Subscription;
  parameterSubscription: Subscription;
  //////////////////////////////////////

  retirementSavingParameter: Parameter | null = null;
  shortFundParameter: FundParameters | null = null;

  employeeInfo = '';

  employeeNumber: string;
  displayedColumns = ['name', 'aportacion', 'rendimiento', 'amount'];
  currentEmployee: Employee;
  data: Array<any> = new Array<any>();
  data2: Array<any> = new Array<any>();

  dataLoanPermanent: Array<any> = new Array<any>();
  dataLoanRetirement: Array<any> = new Array<any>();
  permanentLoanSavings: boolean;
  retirementLoanSavings: boolean;
  loan: Loan = new Loan();
  hideShortFund: boolean;
  dataEmployee: any;
  ContributionArrayFAL: any;
  ContributionArrayFAC: any;
  ContributionArrayCAL: any;
  ContributionArrayCAR: any;
  sharesArrayCAR: any;
  sharesArrayCARRetirement: any;
  minusCAL: any;
  loanPermanent: any;
  loanRetirement: any;
  /////////////////////////////
  dt = moment();
  minuteReset = this.dt.parseZone().utcOffset();
  currentYear = new Date().getFullYear();
  timeYearFrom = new Date(this.currentYear + '-01-01').getTime();

  /** graph  */
  pieChartLabels = [];
  pieChartData = [];
  pieChartData2 = [];
  pieChartOptions: ChartOptions = {
    responsive: true,
    legend: {
      position: 'top',
    },
    tooltips: {
      enabled: true,
      mode: 'single',
      callbacks: {
        label: function (tooltipItems, data) {
          return data.labels[tooltipItems.index] + ' ' + data.datasets[0].data[tooltipItems.index] + ' %';
        }
      }
    },
  };


  pieData = [];

  dataChart: Array<any> = new Array<any>();
  totalsData: any;
  pieChartType = 'pie';
  totalAcumulado = 0;
  totalAportacion = 0;
  totalRendimiento = 0;
  totales = 0;

  //'#1976D2', '#FFC300', '#F70C0C', '#D7DBDD'
  // pieColors = ['rgba(161, 199, 237, 0.32)', 'rgba(255,236,172, 0)', 'rgba(255,148,125, 0)', 'rgba(215, 219, 221, 0.03)'  ];

  constructor(public logicService: LogicService, private authService: AuthenticationService, private dataService: DataSourceService) {
    this.cancelSubscriptions();

    monkeyPatchChartJsTooltip();
    monkeyPatchChartJsLegend();
    this.currentEmployee = null;
    this.data = new Array<any>();

    this.principalSubscription = this.logicService.dataManager.principalDataLoader.changes.subscribe(d => {
      if (d && d.response) {

        this.currentEmployee = d.response;
        const employeeInfoToShow = d && d.response ? 'Colaborador ' + d.response.workInformation.employeeNumber + ' - ' + d.response.displayName : 'Cargando Información ...';

        this.employeeNumber = d.response.workInformation.employeeNumber;
        this.employeeInfo = employeeInfoToShow;
        this.hideShortFund = d && d.response && d.response.funds.find(e => e.type === 'FAC') ? false : true;

        const values = d.response.workInformation.wage.historical.values();
        values.sort((a, b) => b.date.getTime() - a.date.getTime());
        this.procData();
        this.permanentLoanSavings = d.response.permanentSavingsLoan ? true : false;
        this.retirementLoanSavings = d.response.retirementSavingsLoan ? true : false;
        this.ContributionArrayFAL = this.currentEmployee.funds.filter(f => f.type === 'FAL');
        this.ContributionArrayFAC = this.currentEmployee.funds.filter(f => f.type === 'FAC');

        this.ContributionArrayCAR = this.currentEmployee.retirementSavingsData.map(rec => new Contribution(rec)).filter(c => c.subType !== ContributionSubTypesEnum.NotSet && c.subType.toUpperCase().includes('X') === false);
       //this.sharesArrayCAR = this.currentEmployee.retirementSavingsData.map(rec => new Contribution(rec)).filter(c => c.subType !== ContributionSubTypesEnum.NotSet && c.subType.toUpperCase().includes('X') === true);
        this.sharesArrayCARRetirement = this.currentEmployee.retirementSavingsData.map((rec: any) => rec).filter(e => e.subType === "CAR_DR" || e.subType === "CAR_DRE");

        this.loanPermanent = this.currentEmployee.permanentSavingsLoan;
        this.loanRetirement = this.currentEmployee.retirementSavingsLoan;

        this.createRetirementLoan(this.retirementLoanSavings);

        if (this.currentEmployee && this.data.length === 0) {

          if (this.loanPermanent && this.loanPermanent.status === 'active') {
            this.createDataLoan();
          } else {
            // lista de espera 
            this.loanActiveInListPending('permanent');

          }

          this.createData();

        }

      }

    });

    this.parameterSubscription = this.logicService.dataManager.parameterDataLoader.changes.subscribe(p => {
      if (p && p.response) {
        this.procData();
      }

    });

    this.logicService.dataManager.generalDataLoader.load();
    this.logicService.dataManager.parameterDataLoader.load();
  }

  ngOnInit() {
    if (this.logicService.dataManager.principalDataLoader.employee && this.logicService.dataManager.principalDataLoader.employee.workInformation && this.logicService.dataManager.principalDataLoader.employee.workInformation.laidOff) {
      this.authService.signOut();
      return;
    }
    //const totals = { name: 'Gran Total', aportacion: 0, rendimiento: 0, amount: 0 }
    //  this.data.push(totals);

  }

  reload(){
    this.cancelSubscriptions();
    localStorage.clear();
    location.reload();
  }

  get retirementSavings(): boolean {
    return this.currentEmployee.retirementSavingsData === null || this.currentEmployee.retirementSavingsData.length === 0;

  }


  async createData() {
    this.pieChartLabels = [];
    this.pieChartData = [];
    this.pieData = [];
    this.totalAcumulado = 0;
    this.totalAportacion = 0;
    this.totalRendimiento = 0;
    this.pieChartData2 = [];
    if (this.currentEmployee) {
      await this.contributionFAL();
      await this.contributionFAC();
      await this.contributionCAR();
      await this.contributionCAL();

      if (this.data) {
        let hash = {};
        this.data = this.data.filter(o => hash[o.name] ? false : hash[o.name] = true);
        
        const dataArr = new Set(this.pieChartLabels);
        this.pieChartLabels = Array.from(dataArr);

        console.log('data', this.data);

        this.data.map(e => {
          this.totalAcumulado += e.amount;
          this.totalAportacion += e.aportacion;
          this.totalRendimiento += e.rendimiento;
        });

        this.pieChartData2 = this.data.map(e => {
          const res = (e.amount * 100) / this.totalAcumulado
          return Number(res.toFixed(2));
        });
      }

    }


  }

  async contributionFAL() {
    const falSura = await this.dataService.loadEmployeeContributions(ContributionTypesEnum.FAL_SURA, this.employeeNumber, this.timeYearFrom).pipe(take(1)).toPromise();
    const suraInt = falSura.map(x => x.amount).reduce((p, n) => p + n, 0);
    let sura = suraInt < 0 ? 0 : suraInt;
    let totalEmployeeCurrent = 0;
    let totalCompanyCurrent = 0;
    let total = 0;
    let idEmployee;

    this.ContributionArrayFAL.forEach((element: Contribution) => {
      totalEmployeeCurrent += element.employeeAmount;
      totalEmployeeCurrent += element.employeeSettlement;
      totalEmployeeCurrent += element.employeeWithdraw;

      totalCompanyCurrent += element.companyAmount;
      totalCompanyCurrent += element.companySettlement;
      totalCompanyCurrent += element.companyWithdraw;
      idEmployee = element.employeeNumber;

    })

    total = Number((totalEmployeeCurrent + totalCompanyCurrent).toFixed(2));
    if (total > 0) {
      const permanentData = { idEmployee: idEmployee, name: 'Fondo de Ahorro Largo', aportacion: total, rendimiento: sura, amount: total + sura };
      this.data.push(permanentData);
      this.pieChartLabels.push('Fondo de Ahorro Largo');
      this.pieChartData.push(permanentData.amount);
    }
  }

  async contributionFAC() {

    if (!this.hideShortFund && this.shortFundParameter && this.shortFundParameter.fundDates.length) {
      const sd = this.shortFundParameter.fundDates.find(d => d.active);
      const fromReset = moment(sd.startDate).startOf('day').add(this.minuteReset, 'minutes').toDate();
      const toReset = moment(sd.endDate).startOf('day').add(this.minuteReset, 'minutes').toDate();
      // array de contribuciones FAC del ciclo 
      const ContributionFAC = this.ContributionArrayFAC.map(res => new Contribution(res)).filter(x => x.timeStamp >= fromReset.getTime() && x.timeStamp <= toReset.getTime());
      const firstContributionTime: number = ContributionFAC[0] !== undefined ? ContributionFAC[0].timeStamp : new Date().getTime();
      const facSura = (await this.dataService.loadEmployeeContributions('FAC_SURA', this.employeeNumber).pipe(take(1)).toPromise()).filter(x => x.timeStamp > firstContributionTime);
      const suraInt = facSura.map(x => x.amount).reduce((p, n) => p + n, 0);

      let sura = suraInt < 0 ? 0 : suraInt;
      let totalEmployeeCurrent = 0;
      let totalCompanyCurrent = 0;
      let total = 0;
      let idEmployee;

      ContributionFAC.forEach((element: Contribution) => {
        if (element.timeStamp >= fromReset.getTime() && element.timeStamp <= toReset.getTime()) {
          totalEmployeeCurrent += element.employeeAmount;
          totalCompanyCurrent += element.companyAmount;
          idEmployee = element.employeeNumber;

        }

      })

      total = Number ((totalEmployeeCurrent + totalCompanyCurrent).toFixed(2));
      if (total > 0) {
        const retirementData = { idEmployee: idEmployee, name: 'Fondo de Ahorro Corto', aportacion: total, rendimiento: sura, amount: total + sura };
        this.data.push(retirementData);
        this.pieChartLabels.push('Fondo de Ahorro Corto');
        this.pieChartData.push(total + sura);

      }


    }

  }

  async contributionCAR() {

    if (!this.retirementSavings) {

      const carSura = await this.dataService.loadEmployeeContributions('CAR_SURA', this.employeeNumber, this.timeYearFrom).pipe(take(1)).toPromise();
      const suraInt = carSura.map(x => x.amount).reduce((p, n) => p + n, 0);
      let sura = suraInt < 0 ? 0 : suraInt;

      let totalEmployeeCurrent = 0;
      let totalCompanyCurrent = 0;
      /*let totalEmployeeSettlement = 0;
      let totalCompanySettlement = 0;
      let totalSettlement = 0;  */
      let total = 0;
      let idEmployee;

      this.ContributionArrayCAR.forEach((element: Contribution) => {
        totalCompanyCurrent += element.companyAmount;
        totalEmployeeCurrent += element.employeeAmount;
        idEmployee = element.employeeNumber;

       /* if(element.subType === "CAR_AL"){
          totalEmployeeSettlement += element.employeeSettlement ;
          totalCompanySettlement += element.companySettlement ;
        }*/

      });

      //totalSettlement = Number((totalEmployeeSettlement + totalCompanySettlement).toFixed(2));
     // total = Number((totalEmployeeCurrent + totalCompanyCurrent + totalSettlement).toFixed(2));
      total = Number((totalEmployeeCurrent + totalCompanyCurrent ).toFixed(2));

      const rendimientos: number = this.sharesArrayCARRetirement.map(x => x.investmentReturn).reduce((p, n) => p + n, sura);
      const retirementSavingData = { idEmployee: idEmployee, name: 'Caja de Ahorro Retiro', aportacion: total, rendimiento: rendimientos, amount: total + rendimientos };
      this.data.push(retirementSavingData);
      this.pieChartLabels.push('Caja de Ahorro Retiro');
      this.pieChartData.push(retirementSavingData.amount);


    }

  }

  async contributionCAL() {

    if (this.currentEmployee.permanentSavings) {
      this.ContributionArrayCAL = this.currentEmployee.permanentSavingsData.map((rec: any) => new Contribution(rec)).filter(e => e.subType === ContributionSubTypesEnum.CAL_DR || e.subType === ContributionSubTypesEnum.CAL_DRE);
      this.minusCAL = this.currentEmployee.permanentSavingsData.map((rec: any) => new Contribution(rec)).filter(e => e.subType !== ContributionSubTypesEnum.CAL_DR && e.subType !== ContributionSubTypesEnum.CAL_DRE);

      const c2 = await this.dataService.loadEmployeeContributions(ContributionTypesEnum.CAL_SURA, this.employeeNumber, this.timeYearFrom).pipe(take(1)).toPromise().catch(error => {
        console.log(error);
        return [];
      });

      const t1 = this.minusCAL.map(r => r.investmentReturn + r.loanPerformance).reduce((p, n) => p + n, 0);
      const contributionSuraArray: Array<FinancialReturn> = c2.map((rec: any) => new FinancialReturn(rec)).filter(e => e.subType.includes('_SURA'));
      let temp = 0;
      temp = contributionSuraArray.map(x => x.amount).reduce((p, n) => p + n, 0);
      const result = this.ContributionArrayCAL.map(x => x.investmentReturn).reduce((p, n) => p + n, temp);
      let idEmployee = this.ContributionArrayCAL[0] ? this.ContributionArrayCAL[0].employeeNumber : 0;
      let suraAmount = result + t1;
      let rendimientoTotal = suraAmount < 0 ? 0 : suraAmount;

      let sumaTotal = this.currentEmployee.permanentSavings ? (this.currentEmployee.permanentSavings.total + this.currentEmployee.permanentSavings.totalExtras) - this.currentEmployee.permanentSavings.totalWithdrawals : 0;
      let total = Number(sumaTotal.toFixed(2));
      if (total > 0) {
        const permanentSavingData = { idEmployee: idEmployee, name: 'Caja de Ahorro Permanente', aportacion: total, rendimiento: rendimientoTotal, amount: total + rendimientoTotal };
        this.data.push(permanentSavingData);
        this.pieChartLabels.push('Caja de Ahorro Permanente');
        this.pieChartData.push(permanentSavingData.amount);

      }


    }

  }

  createDataLoan() {

    if (this.permanentLoanSavings) {

      const total = this.loanPermanent.scheduleDates.values().filter(element => element.paid).map(element => element.capital).reduce(((prev, next) => next ? prev + next : 0), 0);
      const pending = this.loanPermanent.scheduleDates.values().filter(element => element.paid).length;
      this.dataLoanPermanent = [
        { position: 1, name: 'Monto Solicitado', amount: this.loanPermanent.requestedAmount },
        { position: 2, name: 'Monto Amortizado', amount: total },
        { position: 3, name: 'Número de Cuotas', amount: this.loanPermanent.requestedNumberOfPayments, pending: pending },
        { position: 4, name: 'Monto Pendiente', amount: this.loanPermanent.requestedAmount - total }

      ];

    }


    if (this.retirementLoanSavings) {

      const total = this.loanRetirement.scheduleDates.values().filter(element => element.paid).map(element => element.capital).reduce(((prev, next) => next ? prev + next : 0), 0);
      const pending = this.loanRetirement.scheduleDates.values().filter(element => element.paid).length;

      this.dataLoanRetirement = [
        { position: 1, name: 'Monto Solicitado', amount: this.loanRetirement.requestedAmount },
        { position: 2, name: 'Monto Amortizado', amount: total },
        { position: 3, name: 'Número de Cuotas', amount: this.loanRetirement.requestedNumberOfPayments, pending: pending },
        { position: 4, name: 'Monto Pendiente', amount: this.loanRetirement.requestedAmount - total }

      ];

    }
  }

  createRetirementLoan(retirementLoan: boolean) {

    if (retirementLoan && this.loanRetirement) {

      if (this.loanRetirement.status === 'active') {
        const total: number = this.loanRetirement.scheduleDates.values().filter(element => element.paid).map(element => element.capital).reduce(((prev, next) => next ? prev + next : 0), 0);
        const pending: number = this.loanRetirement.scheduleDates.values().filter(element => element.paid).length;

        this.dataLoanRetirement = [
          { position: 1, name: 'Monto Solicitado', amount: this.loanRetirement.requestedAmount },
          { position: 2, name: 'Monto Amortizado', amount: total },
          { position: 3, name: 'Número de Cuotas', amount: this.loanRetirement.requestedNumberOfPayments, pending: pending },
          { position: 4, name: 'Monto Pendiente', amount: this.loanRetirement.requestedAmount - total }

        ];

      } else {
        // if status review
        this.loanActiveInListPending('retirement');
      }

    }

  }

  procData() {

    if (!this.logicService.dataManager.principalDataLoader.employee || !this.logicService.dataManager.parameterDataLoader.parameters) {
      return;
    }

    const parameters = this.logicService.dataManager.parameterDataLoader.parameters;
    const fundParameters = this.logicService.dataManager.parameterDataLoader.fundParameters;
    this.shortFundParameter = fundParameters.filter(parameterObj => parameterObj.type === PeriodTypeEnum.shortSavingFund).find(e => e.fundAppliesTo(this.currentEmployee));
    this.retirementSavingParameter = parameters.filter(parameterObj => parameterObj.type === PeriodTypeEnum.retirementSaving).find(e => e.savingParameterAppliesTo(this.currentEmployee));
  }

  /**
 * funcion para regresar el prestamo activo en colaboradores en lista de espera
 */
  async loanActiveInListPending(type: string) {
    const loans = await this.dataService.loadLoanActiveListPending(this.employeeNumber, 500, 500);
    let restructuredID: string = '';
    let sumaPaids: number = 0;
    let interes: number = 0;
    let loan: number = 0;
    let interestPercentage: number = 0;
    let activePendingList: Array<any> = [];
    activePendingList = loans.filter(e => e.active === true && e.type === type && (e.status == 'active_pending' || e.status == 'review'));


    if (loans.length > 1 && activePendingList.length > 0) {
      const loanListPending = loans.filter(e => e.active === true && e.type === type && (e.status === 'active_pending' || e.status === 'review'));

      if (loanListPending.length > 0) {
        loanListPending.map(e => restructuredID = e.restructuredID);
      }

    }


    if (restructuredID != '') {
      const loadLoan: any = await this.dataService.loadLoan(restructuredID).pipe(take(1)).toPromise().catch(error => {
        console.log(error);
        return [];
      });
      /*** loadLoan.status == 'restructured' */
      if (loadLoan.status != 'paid' && loadLoan.status != 'withdraw') {
        const cretedAt = loadLoan.createdAt.toDate();
        const interestType = loadLoan.interestType;
        loan = loadLoan.requestedNumberOfPayments;
        interestPercentage = loadLoan.interestPercentage;
        const suma = await this.dataService.loanActiveInPendingList(this.employeeNumber, cretedAt, interestType);
        suma.map(e => {
          sumaPaids = loadLoan.requestedAmount - e.sumPayments;
          loan = e.longPayments
        });
        if (type === 'permanent') {
          this.dataLoanPermanent = [
            { position: 1, name: 'Monto Solicitado', amount: loadLoan.requestedAmount },
            { position: 2, name: 'Monto Amortizado', amount: loadLoan.requestedAmount - sumaPaids },
            { position: 3, name: 'Número de Cuotas', amount: loadLoan.requestedNumberOfPayments, pending: loan },
            { position: 4, name: 'Monto Pendiente', amount: sumaPaids }

          ];

        } else {
          this.dataLoanRetirement = [
            { position: 1, name: 'Monto Solicitado', amount: loadLoan.requestedAmount },
            { position: 2, name: 'Monto Amortizado', amount: loadLoan.requestedAmount - sumaPaids },
            { position: 3, name: 'Número de Cuotas', amount: loadLoan.requestedNumberOfPayments, pending: loan },
            { position: 4, name: 'Monto Pendiente', amount: sumaPaids }

          ];

        }
      }
    }

    interes = loan * sumaPaids * interestPercentage;


    return sumaPaids;
  }


  cancelSubscriptions() {
    this.currentEmployee = null;
    if (this.principalSubscription) {
      this.principalSubscription.unsubscribe();
      this.principalSubscription = null;
    }

    if (this.parameterSubscription) {
      this.parameterSubscription.unsubscribe();
      this.parameterSubscription = null;
    }
  }

  ngOnDestroy(): void {
    this.principalSubscription.unsubscribe();
    this.currentEmployee = null;
    this.principalSubscription = null;
    this.parameterSubscription.unsubscribe();
    this.parameterSubscription = null;



  }

}
